// src/platform/DatasetCoveragePage.jsx
import { useRef } from "react";
import PlatformAdminHeader from "./components/PlatformAdminHeader";
import DatasetCoveragePanel from "./DatasetCoveragePanel";

export default function DatasetCoveragePage() {
  const panelRef = useRef(null);

  return (
    <div className="flex flex-col h-full">
      {/* HEADER */}
      <PlatformAdminHeader
        title="Dataset Coverage"
        subtitle="Imagery dataset footprints"
      />

      {/* BODY */}
      <div className="flex-1 min-h-0">
        <DatasetCoveragePanel ref={panelRef} />
      </div>
    </div>
  );
}